import React from 'react';
import { useTranslation } from 'react-i18next';
import AnimateOnScroll from './AnimateOnScroll';

export default function Problem() {
  const { t } = useTranslation();

  const bullets = [
    t('Problem.bullet1'),
    t('Problem.bullet2'),
    t('Problem.bullet3'),
    t('Problem.bullet4'),
    t('Problem.bullet5'),
  ];

  return (
    <section className="py-20 bg-white" id="problem">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <AnimateOnScroll animation="fadeRight">
            <div>
              <p className="t-h1">{t('Problem.label')}</p>
              <h2 className="t-h2" style={{ maxWidth: '32rem' }}>{t('Problem.title')}</h2>
              <p style={{ color: '#6b7280', lineHeight: 1.7, fontSize: '0.95rem', marginTop: '1rem', maxWidth: '32rem' }}>
                {t('Problem.intro')}
              </p>
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll animation="fadeLeft">
            <div
              className="rounded-2xl p-8"
              style={{ background: 'linear-gradient(135deg, #010C66 0%, #1a237e 100%)' }}
            >
              <p
                className="text-xs font-semibold uppercase tracking-widest mb-4"
                style={{ color: '#709CFF' }}
              >
                {t('Problem.bulletsIntro')}
              </p>
              <ul className="space-y-3 mb-6">
                {bullets.map((bullet, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <div
                      className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
                      style={{ background: 'rgba(112,156,255,0.15)' }}
                    >
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                        <path d="M20 6L9 17l-5-5" stroke="#709CFF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <span style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.95rem' }}>{bullet}</span>
                  </li>
                ))}
              </ul>
              <div className="h-px mb-6" style={{ background: 'rgba(255,255,255,0.1)' }} />
              <p style={{ color: 'rgba(255,255,255,0.7)', lineHeight: 1.7, fontSize: '0.95rem' }}>
                {t('Problem.conclusion')}
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>
  );
}
